import { useMemo } from 'react';

import { StepSourceSpecificationLabel } from './step-source-specification/step-source-specification-label';
import { StepSourceSpecificationContent } from './step-source-specification/step-source-specification-content';
import { stepSourceSpecificationSchema } from './step-source-specification/step-source-specification-schema';

import { StepLocationLabel } from './step-location/step-location-label';
import { StepLocationContent } from './step-location/step-location-content';
import { stepLocationSchema } from './step-location/step-location-schema';

import { StepSubjectAndOvzContent } from './step-subject-and-ovz/step-subject-and-ovz-content';
import { StepSubjectAndOvzLabel } from './step-subject-and-ovz/step-subject-and-ovz-label';
import { stepSubjectAndOvzSchema } from './step-subject-and-ovz/step-subject-and-ovz-schema';

import { StepSummaryLabel } from './step-summary/step-summary-label';
import { StepSummaryContent } from './step-summary/step-summary-content';
import { StepSummaryActions } from './step-summary/step-summary-actions';

export function useMinimalDistancesNew() {
  const steps = useMemo(
    () => [
      // 0
      {
        Label: StepSubjectAndOvzLabel,
        Content: StepSubjectAndOvzContent,
        validationSchema: stepSubjectAndOvzSchema,
      },
      // 1
      {
        Label: StepSourceSpecificationLabel,
        Content: StepSourceSpecificationContent,
        validationSchema: stepSourceSpecificationSchema,
      },
      // 2
      {
        Label: StepLocationLabel,
        Content: StepLocationContent,
        validationSchema: stepLocationSchema,
      },
      // 3
      {
        Label: StepSummaryLabel,
        Content: StepSummaryContent,
        Actions: StepSummaryActions,
      },
    ],
    []
  );

  return { steps };
}
